import { render } from "./EtcItemLeft.vue?vue&type=template&id=2ba5807a&scoped=true"
import script from "./EtcItemLeft.vue?vue&type=script&lang=js"
export * from "./EtcItemLeft.vue?vue&type=script&lang=js"

import "./EtcItemLeft.vue?vue&type=style&index=0&id=2ba5807a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba5807a"]])

export default __exports__